<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BWUe6F/images/Cover.jpg?1684305843152" alt="This image is the cover for the book Abbott: 1973 #1, Abbott: 1973"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Abbott: 1973 #1, Abbott: 1973
      </h1>
      <p class="bookDescription body article font2">
        <p>In a new series for fans of Something is Killing the Children and Bitter Root, Saladin Ahmed, the visionary writer behind Miles Morales: Spider-Man, and Sami Kivelä, the acclaimed artist behind Machine Gun Wizards, reunite for this Must Read supernatural thriller. Detroit’s hardest hitting journalist, Elena Abbott, is trying to make a fresh start at a new newspaper...but her deadly past isn’t ready to let go. The city is days away from the historic election of a Black candidate as their new Mayor, but a vicious new group has emerged to destroy him, targeting anyone who supports his campaign or the change he represents. That means Abbott, who discovers the group’s connection to a dangerous dark magic, has been targeted for certain death - unless she embraces her true power as the Lightbringer to save her city.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Saladin Ahmed, Sami Kivela, Mattia Iacono
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bb06c38